exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".angle-hint[data-v-c1486b54]{-ms-flex-line-pack:center;align-content:center;font-size:.875rem;color:#6f6f6f}", "", {"version":3,"sources":["/home/ponce-dev-staging/report/src/components/Additions/CropEditor.vue"],"names":[],"mappings":"AACA,6BACE,0BAA2B,AACvB,qBAAsB,AAC1B,kBAAoB,AACpB,aAAe,CAChB","file":"CropEditor.vue","sourcesContent":["\n.angle-hint[data-v-c1486b54] {\n  -ms-flex-line-pack: center;\n      align-content: center;\n  font-size: 0.875rem;\n  color: #6F6F6F;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c1486b54","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Additions/CropEditor.vue
// module id = 1523
// module chunks = 0